import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogHistoryinfoComponent } from "./dialog-historyinfo.component";
import { SharedModules } from "src/app/shared.modules";
import { StarItemComponent } from "../../pages/score/stars-and-shadows/score-item-container/star-item/star-item.component";
import { ShadowItemComponent } from "../../pages/score/stars-and-shadows/score-item-container/shadow-item/shadow-item.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { BaseModalComponent } from "../base-modal/base-modal.component";
@NgModule({
  declarations: [DialogHistoryinfoComponent],
  imports: [
    CommonModule,
    SharedModules,
    StarItemComponent,
    ShadowItemComponent,
    AngularSvgIconModule,
    BaseModalComponent,
  ],
})
export class DialogHistoryinfoModule {}
